import React from 'react';
import { Box } from '@mui/material';
import { toneFor } from './severityTokens';

// Status chip read from the rules-engine tag; label + marker shape carry the meaning, color only reinforces it
const StatusChip = ({ label, tone, kind }) => {
    const token = toneFor(tone, kind);
    if (!label || !token) return null;

    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px',
                px: '8px',
                py: '2px',
                borderRadius: '12px',
                border: `1px solid ${token.border}`,
                backgroundColor: token.background,
                color: token.text,
                fontSize: '12px',
                fontWeight: 600,
                lineHeight: '18px',
                whiteSpace: 'nowrap',
            }}
        >
            <span aria-hidden="true">{token.marker}</span>
            {label}
        </Box>
    );
};

export default StatusChip;
